import { render, staticRenderFns } from "./AuditStatusLabel.vue?vue&type=template&id=8d12e198&scoped=true&"
import script from "./AuditStatusLabel.vue?vue&type=script&lang=ts&"
export * from "./AuditStatusLabel.vue?vue&type=script&lang=ts&"
import style0 from "./AuditStatusLabel.vue?vue&type=style&index=0&id=8d12e198&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d12e198",
  null
  
)

export default component.exports